import { Route } from 'vue-router';
import { PAYMENT_PROVIDERS } from '@white-label-configuration/constants';
import { getAppPaymentProvider } from '@white-label-helper/get-app-payment-provider';
import { getAppPaymentProviderConfig } from '@white-label-helper/get-app-payment-provider-config';
import { isDedicatedFlow } from '@white-label-helper/dedicated-flow';

/**
 * Determines whether the current flow is a Sycurio flow.
 *
 * A Sycurio flow is defined as the combination of:
 *   - the active payment provider being Stripe, and
 *   - Sycurio Masking toggle is enabled in the Admin Extranet, and
 *   - the current route being part of the dedicated booking flow
 *
 * @param route - The current Vue Router `Route` instance.
 * @returns {boolean}
 */
export function isSycurioFlow(route: Route): boolean {
  if (getAppPaymentProvider() !== PAYMENT_PROVIDERS.STRIPE) return false;
  if (!isDedicatedFlow(route)) return false;
  return getAppPaymentProviderConfig()?.is_dtmf_masking_enabled ?? false;
}